import { Component } from '@angular/core';

@Component({
  selector: 'fe-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent {

}
